import { Auth } from 'aws-amplify';
import { useInfoPopup } from 'hooks';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getLinkParams } from 'utils/auth';

import { CognitoError, getAmplifyAuthErrorMessage } from '../utils';
import { useResetPasswordForm } from './form';

export const useResetPassword = (location) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { handleSubmit, setValue, ...form } = useResetPasswordForm();
  const { showInfoPopup } = useInfoPopup();

  const { code, userName } = getLinkParams(location.search);

  useEffect(() => {
    if (!code || !userName) {
      showInfoPopup({
        type: 'error',
        title: t('errors.invalidRequest'),
      });
      navigate('/');
    }
  }, []);

  const onFailure = (error: CognitoError) => {
    const title = getAmplifyAuthErrorMessage(t, error);

    showInfoPopup({
      type: 'error',
      title: title === t('auth.userNotFound') ? t('auth.codeExpired') : title,
    });

    navigate('/forgotpassword');
  };

  const onSubmit = handleSubmit(({ password }) => {
    Auth.forgotPasswordSubmit(userName, code, password)
      .then(() => {
        showInfoPopup({
          type: 'success',
          title: t('errors.passwordChanged'),
        });
        navigate('/');
      })
      .catch((err) => {
        onFailure(err);
      });
  });

  return {
    onSubmit,
    setValue,
    ...form,
  };
};
